"use client";
import React from "react";
import { FeaturedDestinationsSection } from "./_components/FeaturedDestination";
import { HighlightsSection } from "./_components/HighlightsSection";
import Image from "next/image";
import { TestimonialsSection } from "./_components/TestimonialsSection";
import { MembershipSection } from "./_components/MembershipSection";
import { GallerySection } from "./_components/GallerySection";
import { ItinerarySection } from "./_components/ItinerarySection";
import { HeroSection } from "./_components/HeroSection";
import { FaqSection } from "../(Home)/(sections)";
import Packages from "./_components/Packages";

const Page = () => {
  return (
    <div className="bg-[#ffffff] flex flex-col items-center w-full min-h-screen">
      <div className="bg-[#ffffff] w-full relative">
        {/* Background elements */}
        {/* <div className="absolute w-full h-full overflow-hidden pointer-events-none z-0">
          <div className="w-full max-w-[1539px] mx-auto mt-[1002px] relative h-[400px]">
            <Image
              src="/rectangle-19.svg"
              alt="Rectangle"
              fill
              className="object-contain"
            />
          </div>

          <div className="w-full mx-auto relative h-[400px]">
            <Image
              src="/group-49.png"
              alt="Group"
              fill
              className="object-contain"
            />
          </div>

          <div className="w-[450px] h-[450px] absolute top-[1823px] right-[65px]">
            <Image
              src="/ellipse-203-1.svg"
              alt="Ellipse"
              fill
              className="object-cover"
            />
          </div>
        </div> */}

        <div>
          {/* <FeaturedDestinationsSection />
          <HighlightsSection />
          <TestimonialsSection />
          <MembershipSection />
          <GallerySection />
          <ItinerarySection />
          <HeroSection />
          <FaqSection /> */}
          <Packages />
        </div>
      </div>
    </div>
  );
};

export default Page;
